.t{justify-content:center;}